export enum LokalOrderStatusEnum {
    New = 1,
    Cancelled = 2,
    Accepted = 3,
    Preparing = 4,
    Scheduled = 5,
    ReadyToDispatch = 6,
    Delivered = 7,
    Packing = 8,
    Dispatch = 9,

    OrderError = 10, //not used in backend
    MissingItem = 11, //not used in backend

    //special UI only, for distinction on the backend
    CancelledByMerchant = 12,
    CancelledByCustomer = 13,
    CancelledByTimeout = 14,
}
